/** @format */

import { FunctionComponent as FC } from 'react';
import styled from 'styled-components';

export const Error: FC<Props> = ({ type = undefined, message }) => {
  return (
    <StyledError $type={type} role="alert">
      {message}
    </StyledError>
  );
};

type Props = {
  message: string;
  type?: string;
};

const StyledError = styled.span<{ $type?: string }>`
  display: block;
  font-size: ${({ theme }) => theme.font.size[0.9375]};
  background-color: #e56e69;
  color: #fdf0ec;
  margin-top: ${({ $type }) => ($type === 'checkbox' || $type === 'radio' ? '0' : '-0.5rem')};
  padding: 0.94rem 0.5rem 0.94rem;
  border-bottom-right-radius: 0.65rem;
  border-bottom-left-radius: 0.65rem;
`;
